import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getLockerById(lockerId, language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/get-locker-by-id",
      language,
      timeZone,
      {lockerId}
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the locker by id ${lockerId}: ${e}`);
    return {
      success: false,
    };
  }
}

export async function getInstalledCodes(lockerId, language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/get-installed-codes",
      language,
      timeZone,
      {lockerId}
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the locker by id ${lockerId}: ${e}`);
    return {
      success: false,
    };
  }
}

export async function installCode(lockerId, dateTime, duration, code, language, timeZone) {
  try {
    // POST: it writes to the door system. The parameters stay in the query string.
    const data = await wsRequestPost(
      "/admin/locker/install-code",
      language,
      timeZone,
      null,
      {lockerId, dateTime, duration, code}
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to install the code. ${e}`);
    return {
      success: false,
      // The backend's reason (code not 4-10 digits, start in the past, …).
      message: e?.payload?.translatedMessage || `${e}`
    };
  }
}

export async function removeCode(lockerId, reference, language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/remove-code",
      language,
      timeZone,
      { lockerId, reference }
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to remove the code. ${e}`);
    return {
      success: false,
      message: e?.payload?.translatedMessage || `${e}`
    };
  }
}

export async function getLockersByFacilityId(facilityId, language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/get-locker-by-facility-id",
      language,
      timeZone,
      {facilityId}
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the locker by facility ${facilityId}: ${e}`);
    return {
      success: false,
    };
  }
}

export async function getLockers(language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker",
      language,
      timeZone,
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the lockers: ${e}`);
    return {
      success: false,
    };
  }
}

export async function addLocker(locker, language, timeZone, cancelToken) {
  try {
    const newLocker = Object.assign({}, locker, {
      facilityId: locker.facility.value,
      MustBeUniquePerSignup: locker.MustBeUniquePerSignup &&
        String(locker.MustBeUniquePerSignup).toLowerCase().trim() === "true"
    });
    const data = await wsRequestPost(
      "/admin/locker/add",
      language,
      timeZone,
      newLocker,
      null,
      cancelToken
    );

    return data;
  } catch (e) {
    console.error(`unable to add the new locker: ${e}`);
    return {
      success: false,
      message: e?.payload?.translatedMessage || `${e}`
    };
  }
}
export async function updateLocker(locker, language, timeZone, cancelToken) {

  const lockerToUpdate = Object.assign({}, locker, {
    lockerType: locker.lockerTypeId,
    facilityId: locker.facility.value,
    mustBeUniquePerSignup: locker.mustBeUniquePerSignup &&
      String(locker.mustBeUniquePerSignup).toLowerCase().trim() === "true"
  });

  try {
    const data = await wsRequestPost(
      "/admin/locker/update",
      language,
      timeZone,
      lockerToUpdate,
      null,
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to update the locker ${locker.id}: ${e}`);
    return {
      success: false,
      message: e?.payload?.translatedMessage || `${e}`
    };
  }
}

export async function deleteLocker(lockerId, language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/delete",
      language,
      timeZone,
      {lockerId},
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to delete locker ${lockerId}: ${e}`);
    return {
      success: false,
      // 409 while a facility or resource group still uses the locker.
      message: e?.payload?.translatedMessage || undefined,
    };
  }
}

export async function getLockerTypes( language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/locker-types",
      language,
      timeZone,
    );

    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the locker type list: ${e}`);
    return {
      success: false,
    };
  }
}

export async function getPropertiesByTypeId( typeId, language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/locker/locker-properties",
      language,
      timeZone,
      {typeId}
    );

    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the locker type list: ${e}`);
    return {
      success: false,
    };
  }
}
